export default "__VITE_ASSET__jhbJ4gdp__"